#import './userNotification.fragment.graphql'

fragment UserProfileFragment on UserProfile {
  id
  nick
  firstName
  lastName
  fullName
  email
  profilePhotoUrl
  systemData {
    cashRegisterList {
      id
      name
      user
    }
    sellers {
      id
      name
    }
    sellRequestApproveLimit
    monthlyFixedExpenses
    lastInvoicesData {
      invoiceType
      lastDate
      lastNumber
    }
  }
  notifications {
    ...UserNotificationFragment
  }
  settings
  lastLoginIp
  lastLoginLocation
  active
  loginAttemps
  lastLoginTry
  roles
  shoppingCart {
    id
    items {
      id
      productId
      productDescription
      productPrice
      quantity
      brand
      productCode
      productPhotoUrl
    }
    total
    itemsCount
  }
}
